import React from 'react';

const Loader = () => {
  return (
    <div className="lds-heart"><div></div></div>
  );
}

export { Loader };
